import {  message } from 'antd'


let globalKey = 0
export const  requestLoading = async <T extends Promise<any>>(request:T)=>{
  let key = globalKey++
  message.loading({content:'加载中...',key:key}, 500000)
  let response = await request
  message.destroy(key)
  return response
}
